<template>
  <!-- 全部企业 -->
  <div class="login-container flex-b-r">
    <div class="login-body">
      <div class="title">
        全部企业
        <p @click="$router.push('/firmsign')" style="cursor: pointer;">
          新建企业
        </p>
      </div>
      <!-- 表单区 --> 
      <div class="firmSign-Body">
        <!-- 暂无数据 -->
        <div class="None-data" v-if="list.length == 0">
          <div class="None-data-figure"></div>
          <div class="None-data-Tips">
            <p>暂无数据</p>
            <p style="cursor: pointer">点击新建或绑定企业</p>
          </div>
        </div>
        <!-- 已有数据 -->
        <div class="cen-region" v-else>
          <div
            class="Options"
            v-for="(item, index) in list"
            :key="index"
            @click.stop="handelClick(item)"
          >
            <div class="dis-div">
              <p class="companyName-p">{{ item.companyName }}</p>

              <div
                :class="
                  item.status == '0'
                    ? 'div-icon'
                    : item.status == '2'
                    ? 'div-icon1'
                    : ''
                "
                @click.stop="handelReExamine(item)"
              ></div>
            </div>
            <p
              class="dele-icon"
              style="cursor: pointer"
              @click.stop="handelDele(item)"
              v-if="item.status == '2'"
            ></p>
          </div>
        </div>
      </div>
      <!-- 按钮 -->
      <div class="SignBtn">
        <div class="btn-box">
          <p class="firm-clickable" @click="$router.push('/firmsign')">返回</p>
          <p class="firm-clickable" @click="handelSkipHomepage">绑定新企业</p>
        </div>
      </div>
    </div>
    <div class="BaseMap"></div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import {
  getBindCompanyAuditByPhone, // 根据手机号获取绑定公司列表
  getUserInfoByPhone, // 根据手机号查询用户信息
  getToken, // 进入公司前获取token
  switchCompany, // 管理员切换企业
  deleteCompanyBindAuditById, //用户删除公司申请记录
} from "../../assets/api/firm/firmLogin";
export default {
  // 组件名称
  name: "firmsign",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      list: [], // 已绑定的公司 数据列表
      ruleForm: {
        phone: "", // 从登陆页拿的手机号 用于获取
      },
      idNumber: "", // id编号
    };
  },
  watch: {},

  // 组件初始化
  created() {
    this.getBindCompanyAuditByPhone();
    this.getUserInfoByPhone();
  },
  // 组件实例挂载完毕
  mounted() {},
  //销毁事件
  destroyed() {},
  // 组件方法
  methods: {
    ...mapActions([
      "SET_TOKEN",
      "SET_USERINFO",
      "SET_LOGINS",
      "SET_COMPANY_INFO",
    ]),
    //点击重新审核
    handelReExamine(item) {
      console.log(item, "11111111");
      if (item.status == "2") {
        this.$router.push({
          path: "/bindFirm",
          query: {
            companyName: item.companyName,
            companyId: item.companyId,
            positionEnumId: item.positionEnumId,
            idCard: item.idCard,
            username: item.username,
          },
        });
      } else {
        this.handelClick(item);
      }
    },
    // 根据手机号查询用户信息
    getUserInfoByPhone() {
      getUserInfoByPhone({ data: localStorage.getItem("phone") }).then(
        (res) => {
          if (res.code == 0 && res.data) {
            /// 已绑定企业 点击进入企业时 固定的请求体中会传 userid 先通过手机号获取用户id存入vuex
            this.$store.commit("SET_USERINFO", res.data);
          }
        }
      );
    },
    // 进入页面通过传递手机号 获取绑定的企业列表
    async getBindCompanyAuditByPhone() {
      var data = {};
      data.data = {
        mobile: localStorage.getItem("phone"),
      };
      const res = await getBindCompanyAuditByPhone(data);
      if (res.code == 0 && res.data.list != null) {
        this.list = res.data.list;
      }
    },
    // 选择项目，进入企业首页
    handelClick(item) {
      var data = {
        data: {
          userId: item.userId,
          companyId: item.companyId,
        },
      };
      // 调用接口获取token
      getToken(data).then((res) => {
        if (res.code == 0) {
          // 将token存入vuex
          this.$store.commit("SET_TOKEN", res.data);
          // 调用用户切换企业接口 获取信息存入vuex并进入企业首页
          var data = {
            data: {
              companyId: item.companyId,
              userId: item.userId,
            },
          };
          var that = this;
          setTimeout(function () {
            switchCompany(data).then((resT) => {
              if (resT.code == 0) {
                that.$store.commit("SET_COMPANY_INFO", resT.data.companyInfo);
                that.$store.commit("SET_USERINFO", resT.data.userInfoVo);
                that.$store.commit("SET_LOGINS", "1");
                that.$tool.PromptBox("success", "登录成功");

                that.$router.push("/FirmHomePage");
                // 登录记录
                that.$tool.checkCompanyLogin(localStorage.getItem("phoneVx"));
              } else {
                that.$tool.PromptBox("error", resT.msg);
              }
            });
          }, 500);
        }
      });
    },
    // 进入绑定企业页面
    handelSkipHomepage() {
      // 页面跳转 绑定企业页面
      // this.$router.push("/bindFirm");
      this.$router.push({
        path: "/bindFirm",
        // query: { type: this.ruleForm.phone },
      });
    },
    // 绑定失败删除展示
    handelDele(item) {
      this.idNumber = item.id;
      this.$confirmWithScroll("是否删除该数据？", "提示", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var data = {
          data: {
            id: this.idNumber,
          },
        };
        deleteCompanyBindAuditById(data).then((res) => {
          if (res.code == 0) {
            this.getBindCompanyAuditByPhone();
            this.$tool.PromptBox("success", "操作成功");
          } else {
            // this.$tool.PromptBox("error", res.msg);
          }
        });
      }).catch(() => {
        // 用户取消
      });
    },
  },
};
</script>

<style scoped lang="less">
// 主体内容
.login-container {
  min-width: 1230px !important;
  height: 100%;
  min-height: 740px;
  display: flex;
  flex-direction: column;
  background: #0054cc;
  background-image: linear-gradient(
    90deg,
    rgba(97, 144, 232, 0.5) 0%,
    rgba(167, 191, 232, 0.5) 99%
  );
  // 中心白色区域
  .login-body {
    // min-width: 0px;
    min-height: 580px !important;
    font-size: 16px;
    margin: auto;
    background-color: #ffffff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    z-index: 999;
    .title {
      // width: 100%;
      height: 80px;
      line-height: 80px;
      // margin-top: 30px;
      font-family: FZLTCHJW--GB1-0;
      font-size: 18px;
      color: #001e50;
      font-weight: 600;
      // text-align: center;
      position: relative;
      padding-left: 40px;
      border-bottom: 1px solid #e7e7e7;
      cursor: pointer;
      p {
        width: 120px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background: #317efc;
        border-radius: 5px;
        position: absolute;
        right: 30px;
        bottom: 20px;
        font-size: 16px;
        color: #ffffff;
        font-weight: 400;
      }
    }
    // 企业注册表单主体
    .firmSign-Body {
      min-width: 1150px;
      min-height: 360px;
      margin-top: 25px;
      display: flex;
      .None-data {
        min-width: 120px;
        min-height: 175px;
        margin: auto;
        // 暂无数据时 显示的图片
        .None-data-figure {
          min-width: 120px;
          min-height: 120px;
          background-image: url("../../assets/imgs/zanwushuju@3x.svg");
          background-size: 100% 100%;
        }
        // 暂无数据提示
        .None-data-Tips {
          width: 110px;
          height: 28px;
          margin-top: 20px;
          p {
            width: 110px;
            height: 14px;
            line-height: 14px;
            text-align: center;
            font-family: PingFangSC-Medium;
            font-size: 12px;
            color: #999999;
            font-weight: 400;
          }
        }
      }
      .cen-region::-webkit-scrollbar {
        display: none;
      }
      // 主体 有数据时展示数据的div
      .cen-region {
        min-width: 540px;
        height: 300px;
        margin: auto;
        overflow: hidden;
        overflow-y: scroll;
        // 火狐隐藏滚动条
        scrollbar-width: none;
        .Options:hover {
          color: #0054cc;
          border: 1px solid #0054cc;
        }
        // 每条数据的div
        .Options {
          width: 500px;
          height: 45px;
          // text-align: left;
          // background: #ffffff;
          border: 1px solid #999999;
          border-radius: 5px;
          font-size: 16px;
          color: #333333;
          font-weight: 400;
          margin-top: 15px;
          cursor: pointer;
          display: flex;
          position: relative;
          background-image: url("../../assets/imgs/img/geren-SVG/2026-Group 427322153.svg");
          background-size: cover; // cover 自动适配，保证铺满且不变形
          background-position: center;
          background-repeat: no-repeat;
          transition: all 0.3s;
          // 删除图标
          .dele-icon {
            position: absolute;
            right: -30px; // 伸出外面
            top: 50%;
            transform: translateY(-50%); // 精确垂直居中
            width: 20px;
            height: 20px;
            background-image: url("../../assets/imgs/img/geren-SVG/2026-18pt-delete-gray.svg");
            background-size: 100% 100%;
            z-index: 999; // 确保层级最高，不被遮挡
            cursor: pointer;
          }
          .dis-div {
            width: 400px;
            height: 40px;
            line-height: 40px;
            margin: auto;
            margin-left: 60px;
            display: flex;
            font-size: 14px;
            .companyName-p {
              width: 350px;
              color: #001e50;
              cursor: pointer;
              // white-space: nowrap;
              // overflow: hidden;
              // text-overflow: ellipsis;
            }
            div {
              width: 80px;
              height: 30px;
              margin: auto;
              margin-left: 10px;
              display: inline;
            }
            .div-icon {
              background-image: url("../../assets/imgs/img/geren-SVG/2026-zhaungtai_under-review.svg");
              // background-size: cover; // cover 自动适配，保证铺满且不变形
              background-position: center;
              background-repeat: no-repeat;
              transition: all 0.3s;
            }
            .div-icon1 {
              background-image: url("../../assets/imgs/img/geren-SVG/2026-zhaungtai-reapply.svg");
              // background-size: cover; // cover 自动适配，保证铺满且不变形
              background-position: center;
              background-repeat: no-repeat;
              transition: all 0.3s;
            }
          }
        }
      }
    }
  }
  // 底图
  .BaseMap {
    width: 100%;
    height: 300px;
    background-image: url("../../assets/imgs/img/beijinglou@2x.png");
    background-size: 100% 100%;
    position: absolute;
    bottom: 0;
  }
}
// 按钮区
.SignBtn {
  width: 100%;
  height: 40px;
  display: flex;
  margin-top: 20px;
  z-index: 99;
  .btn-box {
    width: 300px;
    height: 40px;
    margin: auto;
    display: flex;
    p {
      width: 120px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      margin: auto;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #333333;
      font-weight: 400;
      background: #ffffff;
      box-sizing: border-box;
      border: 1px solid #999999;
      border-radius: 5px;
      cursor: pointer;
    }
    p:nth-child(2) {
      background: #409eff ;
      border-radius: 5px;
      color: #ffffff;
      border: none;
    }
  }
}
</style>
